export default __webpack_public_path__ + "static/media/discover.5c42b0f4.svg";